import { render } from "./Registration.vue?vue&type=template&id=df6bfe66"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\HOSAM\\Desktop\\LIBYA\\qr-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__